interface TallyBarProps {
  selected: number;
  total: number;
  showSelectedOnly: boolean;
  onToggleSelectedOnly: (v: boolean) => void;
}

/**
 * AOZONE-34: thin pinned bar below the FilterBar showing how many of the
 * currently-rendered entries are flagged for the MBR, plus a "Show selected
 * only" toggle. The N/M count reflects the post-filter, categorized set and is
 * independent of the show-selected-only view.
 */
export function TallyBar({
  selected,
  total,
  showSelectedOnly,
  onToggleSelectedOnly,
}: TallyBarProps) {
  return (
    <div className="sticky top-[6.5rem] z-20 border-b border-slate-200 bg-white/95 backdrop-blur">
      <div className="mx-auto flex max-w-[1280px] items-center justify-between gap-3 px-6 py-2 text-sm text-slate-700">
        <span>
          {selected} of {total} selected
        </span>
        <label className="inline-flex items-center gap-2 font-medium">
          <input
            type="checkbox"
            aria-label="Show selected only"
            checked={showSelectedOnly}
            onChange={(e) => onToggleSelectedOnly(e.target.checked)}
            className="h-4 w-4 shrink-0 accent-slate-900"
          />
          Show selected only
        </label>
      </div>
    </div>
  );
}
